import { Component, OnInit } from '@angular/core';
import { DatastoreService } from '../../services/datastore.service';
import {
  faChevronRight,
  faChevronLeft,
} from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'apps/dorsetcouncil-hwrc-booking-service/src/environments/environment';
import { ApiService } from '../../services/jrni/api.service';
import { DepartmentService } from '../../services/jrni/department.service';

@Component({
  selector: 'app-amend-permits-submitted',
  templateUrl: './amend-permits-submitted.component.html',
  styleUrls: ['./amend-permits-submitted.component.scss'],
})
export class AmendPermitsSubmittedComponent implements OnInit {
  parentDepartment: any;
  pageTitle: string;
  guidanceMsg: any;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;

  constructor(
    public datastoreService: DatastoreService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private departmentService: DepartmentService,
  ) { }

  ngOnInit(): void {
    this.scrollToTop();
    this.route.queryParams.subscribe(async params => {

      this.parentDepartment = this.datastoreService.parentDepartment;
      if (!this.parentDepartment) {
        let parentDepartment = await this.departmentService.getParentDepartment();
        this.datastoreService.parentDepartment = parentDepartment;
        this.parentDepartment = this.datastoreService.parentDepartment;
        const pId = parentDepartment.id;
        const pClient = parentDepartment.self.split('://')[1].split('.')[0];
        const token: any = await this.apiService.getToken(pClient, pId);
        if (token) {
          environment.clientToken = token.token;
        }
      }
      console.log(this.parentDepartment);
      const pId = this.parentDepartment.id;
      const pClient = this.parentDepartment.self.split('://')[1].split('.')[0];
      this.datastoreService.config = await this.apiService.getConfig(pClient, pId);
      if (this.datastoreService.config) {
        console.log(this.datastoreService.config.amendHeadings);
        // Set the title on the login page to the title from the business question
        this.datastoreService.config.amendHeadings?.hasOwnProperty(
          params['type']
        )
          ? (this.pageTitle =
            this.datastoreService.config.amendHeadings[params['type']].heading)
          : (this.pageTitle = 'amend_permits_submitted_page_title title not set');

        this.datastoreService.config.amendHeadings?.hasOwnProperty(
          params['type']
        )
          ? (this.guidanceMsg =
            this.datastoreService.config.amendHeadings[params['type']].subHeading)
          : (this.guidanceMsg = 'amend_permits_submitted_page_guidance_text not set');
      } else {
        this.restartJourney();
      }
    });
  }

  restartJourney() {
    this.router.navigate(['/departments']);
  }

  goHome() {
    window.location.href =
      'https://www.thurrock.gov.uk/recycling-waste';
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }
}
